import React from 'react'

const Circular = () => {
  return (
    <div>Circular</div>
  )
}

export default Circular